import { render, staticRenderFns } from "./DocsHeroBanner.vue?vue&type=template&id=e5b48b40&scoped=true"
import script from "./DocsHeroBanner.vue?vue&type=script&lang=js"
export * from "./DocsHeroBanner.vue?vue&type=script&lang=js"
import style0 from "./DocsHeroBanner.vue?vue&type=style&index=0&id=e5b48b40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b48b40",
  null
  
)

export default component.exports